<template>
  <div class="col-sm-12 nopads">
    <div>
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <form
        class="px-2"
        @submit.prevent="onSubmit"
        @reset="onReset"
      >
        <div class="row nopads">
          <div class="col-sm-6 pl-1 pr-1">
            <open-contract-filter
              :to="toDate"
              :from="fromDate"
              :show-company="false"
              :show-only-my-contracts-option="true"
              :contract="preSelectedContract"
              @loading="loading=true"
              @loading-completed="loading=false"
              @contract-selected="setContract"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 nopads pl-1 pr-1">
            <span class="search-title">{{ $t('contract_diary.start') }} - {{
              $t('trip_list.road_sec_from')
            }}</span>
            <input
              v-model="fromDate"
              class="form-control form-control-sm"
              type="date"
            />
          </div>
          <div class="col-sm-6 nopads pl-1 pr-1">
            <span class="search-title">{{ $t('contract_diary.start') }} - {{
              $t('trip_list.road_sec_to')
            }}</span>
            <input
              v-model="toDate"
              class="form-control form-control-sm"
              type="date"
            />
          </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-end">
          <button type="submit" class="btn btn-primary form-button">
            {{ $t('ins_report.search') }}
          </button>
          <button type="reset" class="btn btn-danger form-button">
            {{ $t('ins_report.clear') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import OpenContractFilter from "@/components/contract/OpenContractFilter.vue";

export default {
    name: 'ContractDiarySearch',
    components: {OpenContractFilter},
    mixins: [restApi, timeUtils],
    props: {
        preSelectedContract: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            contract: null,
            fromDate: null,
            toDate: null,
        }
    },
    mounted: function () {
        if (!this.fromDate) {
            this.fromDate = this.timestampToDateInput(this.getMonthStartAsDate().getTime())
        }
        this.contract = this.preSelectedContract
    },
    methods: {
        onSubmit: function () {
            var params = {}
            if (this.contract) {
                params.contract = this.contract
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.startDate = this.localTimeToUtcTime(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.endDate = this.getEndOfTheDay(this.toDate).getTime()
            }
            this.$emit('search', params)
        },

        setContract(contract) {
            this.contract = contract
        },

        onReset: function () {
            this.contract = null
            this.fromDate = null
            this.toDate = null
        }
    }
}
</script>
